//import react section
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
/** Material UI import section */
import { Checkbox, FormControlLabel, FormGroup, ListItem, ListItemText, TextField, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { Translate } from 'react-localize-redux'
import ReactSelect from 'react-select'
import { operationTyperOptions } from '../../../../store/helpers/SelectOptions'
/** Resources import section */
const useStyle = (theme) => ({})

const GeneralData = (props) => {
	//function props section
	const { addPreviousOriging, onUpdateRequest } = props
	//Object props section
	const { loadAlert } = props
	//bool props section
	const { canBeEditData } = props
	const [operationType, setOperationType] = useState('')
	useEffect(() => {
		if (loadAlert && loadAlert.operationType) {
			setOperationType(loadAlert.operationType)
		}
	}, [loadAlert])
	const selectedOption = operationTyperOptions.find((option) => option.value === operationType)
	const onUpdatePropertyCommon = (property, value) => {
		let objectProperties = {
			token: loadAlert.token,
		}
		objectProperties[property] = value
		onUpdateRequest(objectProperties)
	}
	const customStyles = {
		control: (provided) => ({
			...provided,
			height: '32px',
			width: '250px',
		}),
		menu: (provided) => ({
			...provided,
			width: '250px',
			minWidth: '100%',
		}),
		menuList: (provided) => ({
			...provided,
			display: 'flex',
			flexDirection: 'column',
		}),
		singleValue: (provided) => ({
			...provided,
			width: '250px',
		}),
	}
	return (
		<>
			<ListItem>
				<ListItemText
					secondary={
						<React.Fragment>
							<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<Typography
									component='span'
									variant='body2'
									color='textPrimary'
									style={{ whiteSpace: 'nowrap' }}
								>
									<strong>
										{' '}
										<Translate id='loadAlerts.shippingOrder' />:
									</strong>
								</Typography>
								{/* {loadAlert.shippingOrder} */}
								{/* {loadAlert.status === LoadAlertStatus.DRAFT && ( */}
								<TextField
									fullWidth
									id='outlined-size-small'
									label={''}
									onBlur={(event) => {
										onUpdatePropertyCommon('ShippingOrder', event.target.value)
									}}
									variant='outlined'
									InputProps={{
										style: {
											padding: '5px',
											height: '32px',
										},
									}}
									defaultValue={loadAlert ? loadAlert.shippingOrder : '-'}
									disabled={!canBeEditData}
								/>
								{/* )} */}
							</div>
						</React.Fragment>
					}
				/>
				<ListItemText
					secondary={
						<React.Fragment>
							<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<Typography
									component='span'
									variant='body2'
									color='textPrimary'
									style={{ whiteSpace: 'nowrap' }}
								>
									<strong>
										{' '}
										<Translate id='loadAlerts.operationType' />:
									</strong>
								</Typography>
								{/* {loadAlert.operationType} */}
								{/* {loadAlert.status === LoadAlertStatus.DRAFT && ( */}
								<ReactSelect
									placeholder={<Translate id='loadAlerts.operationType' />}
									options={operationTyperOptions}
									value={selectedOption}
									onChange={(selectedOption) => {
										setOperationType(selectedOption.value)
										onUpdatePropertyCommon('OperationType', selectedOption.value)
									}}
									isDisabled={!canBeEditData}
									styles={customStyles}
								/>
								{/* )} */}
							</div>
						</React.Fragment>
					}
				/>
				<ListItemText
					secondary={
						<React.Fragment>
							<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<Typography
									component='span'
									variant='body2'
									color='textPrimary'
									style={{ whiteSpace: 'nowrap' }}
								>
									<strong>
										{' '}
										<Translate id='loadAlerts.internacionalReferenceNumber' />:
									</strong>
								</Typography>
								{/* {loadAlert.referenceNumber}
								{loadAlert.status === LoadAlertStatus.DRAFT && ( */}
								<TextField
									fullWidth
									id='outlined-size-small'
									label={''}
									onBlur={(event) => {
										onUpdatePropertyCommon('ReferenceNumber', event.target.value)
									}}
									variant='outlined'
									InputProps={{
										style: {
											padding: '5px',
											height: '32px',
										},
									}}
									defaultValue={loadAlert.referenceNumber}
									disabled={!canBeEditData}
								/>
								{/* )} */}
							</div>
						</React.Fragment>
					}
				/>
			</ListItem>
			<ListItem>
				<ListItemText
					secondary={
						<React.Fragment>
							<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<FormGroup row>
									<FormControlLabel
										control={
											<Checkbox
												checked={
													loadAlert &&
													loadAlert.items &&
													loadAlert.items.some((x) => x.type === 3)
												}
												onChange={() => {
													if (canBeEditData) addPreviousOriging()
												}}
												value='Si'
											/>
										}
										label={<Translate id='loadAlerts.previousOriginSupplier' />}
									/>
								</FormGroup>
							</div>
						</React.Fragment>
					}
				/>
			</ListItem>
		</>
	)
}

GeneralData.propTypes = {}

GeneralData.defaultProps = {}
export default withRouter(withStyles(useStyle, { withTheme: true })(GeneralData))
